.modal {
  :global {
    .ant-modal-body {
      padding: 0;
    }

    .ant-modal-container {
      border-radius: 14px;
      padding: 0;
    }

    .ant-modal-header {
      border-radius: 14px;
      padding: 16px 24px;
      border-bottom: none;
    }

    .ant-modal-close-x {
      position: absolute;
      top: 0;
      right: 0;
    }

    .ant-modal-close {
      width: 32px;
      height: 32px;
    }
  }
}

.close {
  width: 32px;
  height: 32px;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  border-radius: 8px;
  background-color: var(--bc-color-fill-secondary);
}
